"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const hui_1 = require("@mit/hui");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const moment_1 = __importDefault(require("moment"));
const PeopleController_1 = __importDefault(require("../../api/PeopleController"));
const mobx_react_1 = require("mobx-react");
const VaccineExemptionRequestDrawer_1 = require("./VaccineExemptionRequestDrawer");
const VaccineExemptionComponent = ({ mitId, vaccine_status, vaccine_hold_status, holds }) => {
    var _a;
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isBusy, setIsBusy] = (0, react_1.useState)(false);
    const [isBusyMoreInfo, setIsBusyMoreInfo] = (0, react_1.useState)(false);
    const [isBusyDownload, setIsBusyDownload] = (0, react_1.useState)(false);
    const [isLoadingPersonDetails, setIsLoadingPersonDetails] = (0, react_1.useState)(false);
    const [unAuth, setUnAuth] = (0, react_1.useState)(false);
    const [isError, setError] = (0, react_1.useState)(false);
    const [showExemptionRequest, setShowExemptionRequest] = (0, react_1.useState)(false);
    // const [exemptionFlags, setExemptionFlags] = useState<ExemptFlagModel>();
    const [pageError, setPageError] = (0, react_1.useState)({ error: false, errorText: "" });
    const [pdfDownloadError, setPDFDownloadError] = (0, react_1.useState)("");
    const [hrFlag, setHrFlags] = (0, react_1.useState)(false);
    const [medicalFlag, setMedicalFlags] = (0, react_1.useState)(false);
    const [internationalFlag, setInternationalFlags] = (0, react_1.useState)(false);
    const [tempFlag, setTempFlags] = (0, react_1.useState)(false);
    const [remoteFlag, setRemoteFlags] = (0, react_1.useState)(false);
    const [exemptions, setExemptions] = (0, react_1.useState)();
    const [exemptReason, setExemptReason] = (0, react_1.useState)("");
    const [exemptionId, setExemptionId] = (0, react_1.useState)("");
    const [exemptionUrl, setExemptionURL] = (0, react_1.useState)("");
    const [exemptionData, setExemptionData] = (0, react_1.useState)();
    const [busy, setBusy] = (0, react_1.useState)(false);
    const [personDetails, setPersonDetails] = (0, react_1.useState)();
    const [requestText, setRequestText] = (0, react_1.useState)("");
    const [reFetchPersonExemption, setReFetchPersonExemption] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        fetchPersonExemption();
        fetchPersonVaccineExemptions();
        getPersonalDetails();
    }, [mitId]);
    // Added to refetch the data after an obo exemption was created
    (0, react_1.useEffect)(() => {
        if (reFetchPersonExemption) {
            console.log('Executing fetchPersonExemption()');
            fetchPersonExemption();
            setReFetchPersonExemption(false);
        }
    }, [reFetchPersonExemption]);
    const fetchPersonExemption = () => __awaiter(void 0, void 0, void 0, function* () {
        setBusy(true);
        setIsBusyDownload(true);
        MedicalApi_1.default
            .fetchVaccineExemption(mitId)
            .then((data) => {
            var _a, _b, _c, _d, _e, _f;
            if (data.items && ((_a = data.items) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setExemptReason((_c = (_b = data.items[0]) === null || _b === void 0 ? void 0 : _b.reason) !== null && _c !== void 0 ? _c : "");
                setExemptionId((_d = data.items[0]) === null || _d === void 0 ? void 0 : _d.id);
                setExemptionURL((_f = (_e = data.items[0]) === null || _e === void 0 ? void 0 : _e.imageUrl) !== null && _f !== void 0 ? _f : "");
                setExemptionData(data.items[0]);
                setExemptions(data.items.sort((a, b) => (new Date(b.submissionDate).getTime()) - (new Date(a.submissionDate)).getTime()));
            }
            else {
                setExemptReason("");
            }
            setBusy(false);
        })
            .catch((err) => {
            //TODO
        })
            .finally(() => {
            setIsBusyDownload(false);
            setBusy(false);
        });
    });
    const fetchPersonVaccineExemptions = (silent = false) => {
        if (!silent)
            setLoading(true);
        MedicalApi_1.default.fetchPersonVaccineExemption(mitId).then((response) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            // endpoint -> /vaccine/hold/exemptions/flags
            if (response.error) {
            }
            else if (response.unauth) {
                setUnAuth(true);
            }
            else {
                if (response) {
                    setLoading(false);
                    setMedicalFlags((_b = (_a = response.flags) === null || _a === void 0 ? void 0 : _a.medical) !== null && _b !== void 0 ? _b : false);
                    setHrFlags((_d = (_c = response.flags) === null || _c === void 0 ? void 0 : _c.hr) !== null && _d !== void 0 ? _d : false);
                    setInternationalFlags((_f = (_e = response.flags) === null || _e === void 0 ? void 0 : _e.international) !== null && _f !== void 0 ? _f : false);
                    setTempFlags((_h = (_g = response.flags) === null || _g === void 0 ? void 0 : _g.temp) !== null && _h !== void 0 ? _h : false);
                    setRemoteFlags((_k = (_j = response.flags) === null || _j === void 0 ? void 0 : _j.remote) !== null && _k !== void 0 ? _k : false);
                }
            }
            setLoading(false);
        });
    };
    const getPersonalDetails = () => {
        if (mitId) {
            setIsLoadingPersonDetails(true);
            PeopleController_1.default
                .fetchPersonAws(mitId)
                .then((response) => {
                if (response.detail) {
                    setPersonDetails(response.detail);
                }
            })
                .finally(() => {
                setIsLoadingPersonDetails(false);
            });
        }
    };
    //Remove request more info from this page
    // const submitRequestMoreInfo = () => {
    // 	if (exemptionId) {
    // 		setIsBusyMoreInfo(true);
    // 		medicalApi
    // 			.putExemptionApproval(exemptionId, "M", requestText)
    // 			.then((response) => {
    // 				fetchPersonVaccineExemptions(true);
    // 				getPersonalDetails();
    // 			})
    // 			.catch(() => {
    // 				//TODO
    // 			})
    // 			.finally(() => {
    // 				setIsBusyMoreInfo(false);
    // 			});
    // 	}
    // };
    // const submit = () => {
    // 	const body: ExemptFlagModel = {
    // 		hr: hrFlag,
    // 		international: internationalFlag,
    // 		medical: medicalFlag,
    // 		temp: tempFlag,
    // 		remote: remoteFlag,
    // 	};
    // 	setIsBusy(true);
    // 	medicalApi
    // 		.putPersonVaccineExemption(mitId, body)
    // 		.then((response: PostStatusResponse) => {
    // 			if (response.success) {
    // 				medicalApi.fetchPersonVaccineExemption(mitId).then((response) => {
    // 					if (response) {
    // 						fetchPersonVaccineExemptions(true);
    // 						getPersonalDetails();
    // 					}
    // 				});
    // 			} else {
    // 				setPageError({ error: true, errorText: `An error occurred and the person could not be processed. If the problem persists, please contact ${CONTACT_SUPPORT_LINK}.` });
    // 			}
    // 		})
    // 		.catch(() => {
    // 			setPageError({ error: true, errorText: `An error occurred and the person could not be processed. If the problem persists, please contact ${CONTACT_SUPPORT_LINK}.` });
    // 		})
    // 		.finally(() => {
    // 			setIsBusy(false);
    // 		});
    // };
    const selectExemption = (data) => {
        setPageError({ error: false, errorText: "" });
        setMedicalFlags(data === "medical_exemption" ? true : false);
        setHrFlags(data === "hr_exemption" ? true : false);
        setInternationalFlags(data === "international_exemption" ? true : false);
        setTempFlags(data === "temp_exemption" ? true : false);
        setRemoteFlags(data === "remote_exemption" ? true : false);
    };
    const downloadFile = (data, filename, mime) => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const blob = new Blob([data], { type: mime || "application/octet-stream" });
        //@ts-ignore
        if (typeof window.navigator.msSaveBlob !== "undefined") {
            // IE doesn't allow using a blob object directly as link href.
            // Workaround for "HTML7007: One or more blob URLs were
            // revoked by closing the blob for which they were created.
            // These URLs will no longer resolve as the data backing
            // the URL has been freed."
            //@ts-ignore
            window.navigator.msSaveBlob(blob, filename);
            return;
        }
        // Other browsers
        // Create a link pointing to the ObjectURL containing the blob
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", filename);
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(blobURL);
        }, 100);
    };
    const downloadPDF = () => {
        if (exemptionId) {
            setIsBusyDownload(true);
            MedicalApi_1.default
                .fetchVaccineExemptionPDF(exemptionId)
                .then((resp) => {
                downloadFile(resp, `exemption_${(0, moment_1.default)().format("YYYY-MM-DD")}.pdf`, "application/pdf");
            })
                .catch((err) => {
                setPDFDownloadError(err);
            })
                .finally(() => setIsBusyDownload(false));
        }
    };
    const getVaccineStatusText = () => {
        var _a;
        switch ((_a = personDetails === null || personDetails === void 0 ? void 0 : personDetails.vaccine_status) !== null && _a !== void 0 ? _a : vaccine_status) {
            case "full":
                return "Fully Vaccinated";
            case "partial":
                return "Partially Vaccinated";
            case "exempt":
                return "Exempt";
            case "none":
                return "Not Vaccinated";
            case "No Status":
                return "Unknown Vaccination Status";
        }
    };
    if (isError)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Oops.. something went wrong", type: hui_1.ErrorType.Generic });
    if (unAuth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    const items = [
        {
            title: "Temporary Exemption",
            selected: tempFlag,
            value: tempFlag,
            name: "temp_exemption",
            required: false,
            showInput: false,
        },
        {
            title: "Medical Exemption",
            selected: medicalFlag,
            value: medicalFlag,
            name: "medical_exemption",
            required: false,
            showInput: false,
        },
        {
            title: "HR Exemption",
            selected: hrFlag,
            value: hrFlag,
            name: "hr_exemption",
            required: false,
            showInput: false,
        },
        {
            title: "International Exemption",
            selected: internationalFlag,
            value: internationalFlag,
            name: "international_exemption",
            required: false,
            showInput: false,
        },
    ];
    const columns = [
        {
            id: "typeName",
            name: "Type",
            sortable: false,
            options: {
                demandPopin: true,
                // minWidth: 300,
                popinText: "Type",
            },
            filterable: false,
        },
        {
            id: "exemptFrom",
            name: "From",
            sortable: false,
            options: {
                demandPopin: true,
                // minWidth: 200,
                popinText: "From",
            },
            filterable: false,
        },
        // {
        // 	id: "reason",
        // 	name: "Reason",
        // 	sortable: false,
        // 	options: {
        // 		demandPopin: true,
        // 		// minWidth: 500,
        // 		popinText: "Reason",
        // 	},
        // 	filterable: false,
        // },
        // {
        // 	id: "feedback",
        // 	name: "Feedback",
        // 	sortable: false,
        // 	options: {
        // 		demandPopin: true,
        // 		// minWidth: 500,
        // 		popinText: "Feedback",
        // 	},
        // 	filterable: false,
        // },
        {
            id: "expiryDate",
            name: "Expiry Date",
            sortable: false,
            options: {
                demandPopin: true,
                // minWidth: 500,
                popinText: "Expiry Date",
            },
            filterable: false,
        },
        {
            id: "statusText",
            name: "Status",
            sortable: false,
            options: {
                demandPopin: true,
                // minWidth: 300,
                popinText: "Status",
            },
            filterable: false,
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("h4", Object.assign({ className: "medical-holds profile-table-headers" }, { children: ["Exemptions\u00A0\u00A0\u00A0", (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.TextNaked, text: "Create Exemption", icon: "file-excel", onClick: () => setShowExemptionRequest(true) })] })), exemptions &&
                (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-12" }, { children: (0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, items: exemptions.map(exemption => {
                                return {
                                    typeName: exemption.typeName,
                                    exemptFrom: exemption.exemptFrom,
                                    // reason: exemption.reason,
                                    // feedback: exemption.feedback,
                                    expiryDate: exemption.expiryDate ? exemption.expiryDate.substring(0, 10) : '',
                                    statusText: exemption.statusText,
                                    imageUrl: exemption.imageUrl
                                };
                            }), isLoading: isLoading, actionButtons: [
                                {
                                    icon: 'file-alt',
                                    onClick: (exemption) => window.open(exemption.imageUrl),
                                    padded: false,
                                    shouldDisplay: (exemption) => { return exemption.imageUrl ? true : false; },
                                    state: 0,
                                    text: '',
                                    type: 64
                                },
                            ], sortStateOptions: {
                                enabled: true,
                                key: 'covid-medical-person-holds'
                            } }) })) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row py-3" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-6" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "py-1", style: { fontWeight: 600 } }, { children: "Vaccine Status" })), (0, jsx_runtime_1.jsx)("div", { children: isLoadingPersonDetails ? (0, jsx_runtime_1.jsx)(hui_1.Textbox, { isLoading: true, name: "loading" }) : (0, jsx_runtime_1.jsx)(hui_1.Text, { content: getVaccineStatusText(), bold: true, type: "h4" }) }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "py-1", style: { fontWeight: 600 } }, { children: "Vaccine Hold Status" })), (0, jsx_runtime_1.jsx)("div", { children: isLoadingPersonDetails ? (0, jsx_runtime_1.jsx)(hui_1.Textbox, { isLoading: true, name: "loading" }) : (0, jsx_runtime_1.jsx)(hui_1.Text, { content: (_a = personDetails === null || personDetails === void 0 ? void 0 : personDetails.vaccine_hold_status) !== null && _a !== void 0 ? _a : vaccine_hold_status, bold: true, type: "h5" }) }), (0, jsx_runtime_1.jsx)("div", { children: isLoading ? ((0, jsx_runtime_1.jsx)(hui_1.ActionList, { isLoading: true, items: [] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [pageError.error && (0, jsx_runtime_1.jsx)(react_bootstrap_1.Alert, Object.assign({ variant: "danger" }, { children: pageError.errorText })), (0, jsx_runtime_1.jsx)("div", { className: "radio-group" })] })) })] })), (0, jsx_runtime_1.jsx)("div", { className: "col-6" })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "d-flex justify-content-center pt-2" }, { children: (0, jsx_runtime_1.jsx)("div", { className: "btn-padded" }) })), showExemptionRequest &&
                (0, jsx_runtime_1.jsx)(VaccineExemptionRequestDrawer_1.VaccineExemptionRequestDrawer, { setReFetchPersonExemption: setReFetchPersonExemption, show: showExemptionRequest, onClose: () => setShowExemptionRequest(false), done: () => {
                        setShowExemptionRequest(false);
                    }, personDetails: personDetails })] }));
};
const VaccineExemption = (0, mobx_react_1.inject)("searchUser", "covidNav", "holds", "roles")((0, mobx_react_1.observer)(VaccineExemptionComponent));
exports.default = VaccineExemption;
